export const 계약 = {
  contractId: 4980,
  cid: 1919,
  week: 1,
  startDate: '2025-07-21',
  endDate: '2025-07-27',
  isExtend: false,
  usingFee: 330000,
  longTermDiscount: 0,
  earlyDiscount: 0,
  mgmtFee: 30000,
  cleanFee: 50000,
  contractFee: 40590,
  realUsingFee: 450590,
  deposit: 330000,
  finalPayFee: 780590,
  refundType: 'SOFT',
  refundTerms: [
    {
      fromDate: null,
      toDate: '2025-05-28',
      fromDateDiffDays: null,
      toDateDiffDays: 15,
      cancelFeePercent: 0,
    },
    {
      fromDate: '2025-05-29',
      toDate: '2025-06-04',
      fromDateDiffDays: 14,
      toDateDiffDays: 8,
      cancelFeePercent: 20,
    },
    {
      fromDate: '2025-06-05',
      toDate: '2025-06-11',
      fromDateDiffDays: 7,
      toDateDiffDays: 1,
      cancelFeePercent: 40,
    },
    {
      fromDate: '2025-06-12',
      toDate: null,
      fromDateDiffDays: 0,
      toDateDiffDays: null,
      cancelFeePercent: null,
    },
  ],
  cancelFee: null,
  cancelFeePercent: null,
  refundAmount: null,
  calculatedCancelFeePercent: null,
  calculatedCancelFee: null,
  calculatedContractFee: null,
  calculatedRefundAmount: null,
  contractRequestTime: '2025-06-12T17:48:20',
  approveTime: null,
  payDeadlineTime: null,
  contractCompleteTime: null,
  checkinTime: null,
  leaveConfirmTime: null,
  checkFinishTime: null,
  cancelTime: null,
  closedTime: null,
  transactionId: null,
  orderNumber: null,
  payType: null,
  vaBankName: null,
  vaAccountHolder: null,
  vaAccount: null,
  rid: 1468,
  roomName: '테스트',
  addrLot: '서울특별시 서초구 잠원동 15-10 라성빌딩',
  addrStreet: '서울특별시 서초구 나루터로 59',
  picMain: 'room/6fa09fbc-6fd7-45bf-bc0c-edd3e60aa80c.jpg',
  hostUid: 944,
  hostName: '곽민아',
  hostPhoneNumber: '계약이 확정된 후 연락처가 공개됩니다.',
  guestUid: 961,
  guestName: '곽민아',
  guestPhoneNumber: '0101234567890',
  isCancelAvailable: false,
  isPayAvailable: false,
  isRefundAvailable: false,
}

export const 승인_대기 = {
  ...계약,
  contractStatus: 'APPROVE_READY',
  contractStatusDescription: '호스트의 승인을 기다리고 있습니다.',
  contractRequestTime: '2025-06-12T17:48:20',
  isCancelAvailable: true,
}

export const 결제_대기 = {
  ...계약,
  contractStatus: 'PAY_READY',
  contractStatusDescription: '결제 시 계약이 확정됩니다.',
  contractRequestTime: '2025-06-12T17:48:20',
  approveTime: '2025-06-12T17:50:03',
  payDeadlineTime: '2025-06-12T23:50:03',
  transactionId: 't33m220250612175003Mvqn9',
  orderNumber: 'TEST00004980',
  payType: 'ACCOUNT',
  vaBankName: '신한은행',
  vaAccountHolder: '삼삼엠투',
  vaAccount: 'X3790109027230',
  isCancelAvailable: true,
  isPayAvailable: true,
}

// 카드 결제 & 계좌 결제
export const 계약_확정 = {
  ...계약,
  contractStatus: 'CONTRACT_COMPLETE',
  contractStatusDescription: '계약이 확정되었습니다.',
  cancelFee: 0,
  cancelFeePercent: 0,
  refundAmount: 0,
  calculatedCancelFeePercent: 10,
  calculatedCancelFee: 33000,
  calculatedContractFee: 4059,
  calculatedRefundAmount: 743531,
  contractRequestTime: '2025-06-12T17:48:20',
  approveTime: '2025-06-12T17:50:03',
  payDeadlineTime: '2025-06-12T23:50:03',
  contractCompleteTime: '2025-06-12T17:51:38',
  hostPhoneNumber: '01026537460',
  isRefundAvailable: true,
}

export const 게스트_결제_전_취소 = {
  ...계약,
  contractStatus: 'CANCEL',
  contractStatusDescription: '계약이 취소되었습니다.',
  contractRequestTime: '2025-06-12T17:48:20',
  closedTime: '2025-06-12T17:56:02', // 결제 전 취소 : closedTime, 결제 후 취소 : cancelTime
}

export const 호스트_거절_취소 = {
  ...계약,
  contractStatus: 'CANCEL',
  contractStatusDescription:
    '호스트가 요청을 승인하지 않아 계약이 취소되었습니다.',
  contractRequestTime: '2025-06-12T17:48:20',
  closedTime: '2025-06-12T17:59:24',
}

export const 입주_확인 = {
  ...계약,
  contractStatus: 'CONTRACT_COMPLETE',
  contractStatusDescription: '계약이 확정되었습니다.',
  cancelFee: 0,
  cancelFeePercent: 0,
  refundAmount: 0,
  contractRequestTime: '2025-06-12T18:00:32',
  approveTime: '2025-06-12T18:01:13',
  payDeadlineTime: '2025-06-12T23:59:59',
  contractCompleteTime: '2025-06-12T18:02:16',
  checkinTime: '2025-06-12T18:10:54',
  hostPhoneNumber: '01026537460',
}

export const 중도_퇴실 = {
  ...계약,
  contractStatus: 'CONTRACT_COMPLETE',
  contractStatusDescription: '계약이 확정되었습니다.',
  cancelFee: 0,
  cancelFeePercent: 0,
  refundAmount: 0,
  contractRequestTime: '2025-06-12T18:00:32',
  approveTime: '2025-06-12T18:01:13',
  payDeadlineTime: '2025-06-12T23:59:59',
  contractCompleteTime: '2025-06-12T18:02:16',
  checkinTime: '2025-06-12T18:10:54',
  leaveConfirmTime: '2025-06-12T18:44:06',
  hostPhoneNumber: '01026537460',
}

export const 퇴실_확인 = {
  ...계약,
  contractStatus: 'CONTRACT_COMPLETE',
  contractStatusDescription: '계약이 확정되었습니다.',
  cancelFee: 0,
  cancelFeePercent: 0,
  refundAmount: 0,
  contractRequestTime: '2025-06-12T18:00:32',
  approveTime: '2025-06-12T18:01:13',
  payDeadlineTime: '2025-06-12T23:59:59',
  contractCompleteTime: '2025-06-12T18:02:16',
  checkinTime: '2025-06-12T18:10:54',
  leaveConfirmTime: '2025-06-12T18:44:06',
  checkFinishTime: '2025-06-13T17:45:47',
  hostPhoneNumber: '01026537460',
}

export const 환불_대기 = {
  ...계약,
  contractStatus: 'REFUND',
  contractStatusDescription: '3일 이내에 환불이 완료됩니다.',
  cancelFee: 33000,
  cancelFeePercent: 10,
  refundAmount: 707000,
  contractRequestTime: '2025-06-12T17:48:20',
  approveTime: '2025-06-12T17:50:03',
  payDeadlineTime: '2025-06-12T23:50:03',
  contractCompleteTime: '2025-06-12T17:51:38',
  cancelTime: '2025-06-12T17:53:38',
  hostPhoneNumber: '01026537460',
}

export const 환불_완료 = {
  ...계약,
  contractStatus: 'REFUND',
  contractStatusDescription: '환불이 완료되었습니다.',
  cancelFee: 33000,
  cancelFeePercent: 10,
  refundAmount: 707000,
  contractRequestTime: '2025-06-12T17:48:20',
  approveTime: '2025-06-12T17:50:03',
  payDeadlineTime: '2025-06-12T23:50:03',
  contractCompleteTime: '2025-06-12T17:51:38',
  cancelTime: '2025-06-12T17:53:38',
  closedTime: '2025-06-12T17:54:53',
  hostPhoneNumber: '01026537460',
}

export const 연장_승인_대기 = {
  ...계약,
  contractId: 4985,
  contractStatus: 'APPROVE_READY',
  contractStatusDescription: '호스트의 승인을 기다리고 있습니다.',
  week: 1,
  startDate: '2025-06-20',
  endDate: '2025-06-26',
  isExtend: true,
  cleanFee: 0,
  contractFee: 35640,
  realUsingFee: 395640,
  deposit: 0,
  finalPayFee: 395640,
  refundTerms: [
    {
      fromDate: null,
      toDate: '2025-06-05',
      fromDateDiffDays: null,
      toDateDiffDays: 15,
      cancelFeePercent: 0,
    },
    {
      fromDate: '2025-06-06',
      toDate: '2025-06-12',
      fromDateDiffDays: 14,
      toDateDiffDays: 8,
      cancelFeePercent: 20,
    },
    {
      fromDate: '2025-06-13',
      toDate: '2025-06-19',
      fromDateDiffDays: 7,
      toDateDiffDays: 1,
      cancelFeePercent: 40,
    },
    {
      fromDate: '2025-06-20',
      toDate: null,
      fromDateDiffDays: 0,
      toDateDiffDays: null,
      cancelFeePercent: null,
    },
  ],
  contractRequestTime: '2025-06-13T15:18:23',
  hostPhoneNumber: '01026537460',
  isCancelAvailable: true,
}

export const 연장_결제_대기 = {
  ...계약,
  contractId: 4985,
  contractStatus: 'PAY_READY',
  contractStatusDescription: '결제 시 계약이 확정됩니다.',
  week: 1,
  startDate: '2025-06-20',
  endDate: '2025-06-26',
  isExtend: true,
  cleanFee: 0,
  contractFee: 35640,
  realUsingFee: 395640,
  deposit: 0,
  finalPayFee: 395640,
  refundTerms: [
    {
      fromDate: null,
      toDate: '2025-06-05',
      fromDateDiffDays: null,
      toDateDiffDays: 15,
      cancelFeePercent: 0,
    },
    {
      fromDate: '2025-06-06',
      toDate: '2025-06-12',
      fromDateDiffDays: 14,
      toDateDiffDays: 8,
      cancelFeePercent: 20,
    },
    {
      fromDate: '2025-06-13',
      toDate: '2025-06-19',
      fromDateDiffDays: 7,
      toDateDiffDays: 1,
      cancelFeePercent: 40,
    },
    {
      fromDate: '2025-06-20',
      toDate: null,
      fromDateDiffDays: 0,
      toDateDiffDays: null,
      cancelFeePercent: null,
    },
  ],
  contractRequestTime: '2025-06-13T15:18:23',
  approveTime: '2025-06-13T15:57:38',
  payDeadlineTime: '2025-06-13T21:57:38',
  transactionId: 't33m220250613155739MkhD3',
  orderNumber: 'TEST00004985',
  payType: 'ACCOUNT',
  vaBankName: '신한은행',
  vaAccountHolder: '삼삼엠투',
  vaAccount: 'X3790109035403',
  hostPhoneNumber: '계약이 확정된 후 연락처가 공개됩니다.',
  isCancelAvailable: true,
  isPayAvailable: true,
}

export const 연장_미결제_취소 = {
  ...계약,
  contractId: 4985,
  contractStatus: 'CANCEL',
  contractStatusDescription: '결제가 완료되지 않아 계약이 취소되었습니다.',
  week: 1,
  startDate: '2025-06-20',
  endDate: '2025-06-26',
  isExtend: true,
  contractFee: 35640,
  realUsingFee: 395640,
  deposit: 0,
  finalPayFee: 395640,
  refundTerms: [
    {
      fromDate: null,
      toDate: '2025-06-05',
      fromDateDiffDays: null,
      toDateDiffDays: 15,
      cancelFeePercent: 0,
    },
    {
      fromDate: '2025-06-06',
      toDate: '2025-06-12',
      fromDateDiffDays: 14,
      toDateDiffDays: 8,
      cancelFeePercent: 20,
    },
    {
      fromDate: '2025-06-13',
      toDate: '2025-06-19',
      fromDateDiffDays: 7,
      toDateDiffDays: 1,
      cancelFeePercent: 40,
    },
    {
      fromDate: '2025-06-20',
      toDate: null,
      fromDateDiffDays: 0,
      toDateDiffDays: null,
      cancelFeePercent: null,
    },
  ],
  contractRequestTime: '2025-06-13T15:18:23',
  approveTime: '2025-06-13T15:57:38',
  payDeadlineTime: '2025-06-13T21:57:38',
  closedTime: '2025-06-13T21:59:00',
}
